import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2707">
      <div className="dark" data-id="element-2708">
        <Hero data-id="element-2709" />
      </div>
      <WhyUs data-id="element-2710" />
      <ByTheNumbers data-id="element-2711" />
      <Services data-id="element-2712" />
      <HowItWorks data-id="element-2713" />
      <FAQ data-id="element-2714" />
      <Reviews data-id="element-2715" />
      <CtaBanner data-id="element-2716" />
    </main>;
}